import { Outlet } from "react-router-dom";
import Layout from "../../layout/Layout";

function Accounts() {

  return <Layout><Outlet /></Layout>;
}

export default Accounts;
